// Path: src/components/chat/InputField.tsx
// Moved API key to environment variable
// 06/07/25 10:35 AM +07
import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import OpenAI from 'openai';

const InputContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0.5rem;
  background: #fff;
`;

const PromptButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;
// WARNING: Using environment variable for API key. Ensure .env is secure and not committed to version control.
const client = new OpenAI({
  apiKey: import.meta.env.VITE_XAI_API_KEY,
  baseURL: 'https://api.x.ai/v1',
  dangerouslyAllowBrowser: true, // Enabled for development, use with caution
});

const InputField: React.FC<{
  newMessage: string;
  setNewMessage: (msg: string) => void;
  handleSendMessage: (msg: string) => void;
  isInputDisabled: boolean;
  hasSentFirstMessage: boolean;
  prompts: string[];
  onPromptClick: (prompt: string) => void;
}> = ({ newMessage, setNewMessage, handleSendMessage, isInputDisabled, hasSentFirstMessage, prompts, onPromptClick }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGrokResponse = useCallback(async (message: string) => {
    setIsLoading(true);
    try {
      const completion = await client.chat.completions.create({
        model: 'grok-3-mini',
        messages: [
          { role: 'system', content: 'You are Grok, a helpful chatbot.' },
          { role: 'user', content: message },
        ],
      });
      const response = completion.choices[0].message.content;
      handleSendMessage(response || 'No response from Grok.');
      console.log("Reasoning Content:", completion.choices[0].message.reasoning_content);
      console.log("\nFinal Response:", response);
      console.log("\nNumber of completion tokens (input):", completion.usage.completion_tokens);
      console.log("\nNumber of reasoning tokens (input):", completion.usage.completion_tokens_details.reasoning_tokens);
    } catch (error) {
      handleSendMessage(`Error with Grok: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsLoading(false);
    }
  }, [handleSendMessage]);

  return (
    <InputContainer>
      <PromptButtons>
        {prompts.map((prompt) => (
          <Button key={prompt} onClick={() => onPromptClick(prompt)}>{prompt}</Button>
        ))}
      </PromptButtons>
      <input
        placeholder="Reply"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && (isLoading ? null : handleGrokResponse(newMessage))}
        disabled={isInputDisabled || isLoading}
        maxLength={!hasSentFirstMessage ? 20 : undefined}
        aria-label="Chat input"
      />
      <Button onClick={() => !isLoading && handleGrokResponse(newMessage)} disabled={isInputDisabled || isLoading}>
        <SendOutlined />
      </Button>
    </InputContainer>
  );
};

export default React.memo(InputField);